import "layui";
import "layui/dist/css/layui.css";
import $ from "jquery";

function createNavbar() {
  // 创建 style 标签
  const style = document.createElement("style");
  style.textContent = `
		  * {
  margin: 0;
  padding: 0;
  font-family: Microsoft YaHei;
}
html,
body {
  width: 100%;
  min-width: 1300px;
}
@media (min-width: 3440px) {
body {
  width: 1920px;
  margin: 0 auto !important;
}
}
}
li {
  list-style: none;
}
a {
  text-decoration: none;
  color: inherit;
}
:root {
  --primary-color: #fff;
  --hover-color: #0eca90;
  --background-color: rgba(240, 242, 246, 0);
  --border-color: #fff;
  --search-border-color: #e6e6e6;
  --search-bg-color: #ffffff9e;
}

.title {
  width: 100% !important;
  background-color: var(--search-bg-color)   !important;
  height: 67px !important;
  position: absolute !important;
  top: 0 !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  z-index: 99999 !important;
}


.title-child {
  width: 1200px;
  height: 100% !important;
  margin: 0 auto !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
}

.title-child .nav {
  display: flex  !important;
  list-style: none  !important;
  padding: 0  !important;
  margin: 0  !important;
}

.title-child .nav-list {
  height: 68px  !important;
  font-size: 16px  !important;
  line-height: 68px  !important;
  color: #000;
  margin: 0 7.5px  !important;
  position: relative !important;
  font-family: "Microsoft YaHei", sans-serif !important;
}
.title-child .nav-list a{
  display: flex !important;
  align-items: center!important;
  font-family: "Microsoft YaHei", sans-serif !important;
}
.tabContentTitle {
  color: #0eca90 !important;
  width: 50% !important;
  height: auto  !important;
}

.second-nav {
  position: fixed !important;
  top: 100% !important;
  left: 50% !important;
  transform: translate(-50%, 0) !important;
  width: 1300px !important;
  height: auto !important;
  display: none !important;
}

.title-child .nav-list:hover .second-nav {
  display: block !important;
}

.title-child .nav-list:hover .triangle {
  display: block !important;
}

.title-child .nav-list:hover .heng {
  display: block !important;
}

.title-child a {
  color: #000 !important;
  text-decoration: none !important;
}

.search-container {
  height: 32px !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center!important;
}

.search-container input {
  width: 150px !important;
  height: 100% !important;
  border: none !important;
  outline: none   !important;
  padding: 0 !important;
}

.search-container button {
  width: 30px !important;
  border: none !important;
  background: none !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.tab-container {
  width: 100%   !important;
  max-width: 1210px !important;
  margin: auto !important;
  min-height: 400px !important;
  display: flex !important;
}

.tab-links {
  width: 280px !important;
  height: auto !important;
  background-color: #F5F5F5 !important;
}

.tab-links li {
  height: 18px !important;
  line-height: 18px !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  margin-left: 20px !important;
  cursor: pointer !important;
  margin-bottom: 30px !important;
  width: 130px !important;
  color: #595959;
  &:nth-child(1) {
    margin-top: 50px !important;
  }
}

.tab-links li.active {
  border-bottom: 2px solid #0eca90 !important;
  color: #0eca90 !important;
}

.tab-content {
  width: 932px !important;
  height: 100% !important;
  min-height: 400px !important;
  background-color: #fff !important;
  display: block  !important;
  padding-left: 30px  !important;
}

.tab-pane {
  display: none !important;
}

.tab-pane-child {
  width: 100%   !important;
  height: 100% !important;
  display: flex !important;
  flex-wrap: wrap !important;
}

.tabContentPro {
  width: 300px !important;
  height: auto !important;
}

.tab-pane.active {
  display: block !important;
}

.tabContentListTitle {
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #595959  !important;
  width: 100% !important;
  height: 30px  !important;
  line-height: 30px !important;
  margin-bottom: 10px !important;
}

.tabContentListTitle:hover {
  color: #0eca90 !important;
}

.triangle {
  width: 0 !important;
  height: 0 !important;
  border-left: 15px solid transparent !important;
  border-right: 15px solid transparent !important;
  border-bottom: 20px solid #fff !important;
  position: absolute !important;
  top: 50px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  display: none !important;
}

.heng {
  width: 100% !important;
  height: 2px !important;
  background-color: #0eca90 ;
  position: absolute !important;
  top: 0% !important;
  left: 0%;
  display: none !important;
}

.second-nav-typeTwo {
  width: 150px !important;
  height: 110px !important;
  background-color: #fff !important;
  position: absolute !important;
  top: 100% !important;
  left: -25% !important;
  z-index: 10 !important;
  display: none !important;

  div {
    text-align: center !important;
    height: 40px !important;

    a {
      font-size: 14px !important;
      color: #595959 !important;
      padding-left: 30px!important;
    }
  }
}

.second-nav-typeTwo div:hover a {
  color: #0eca90 !important;
}

.title-child .nav-list:hover .second-nav-typeTwo {
  display: block !important;
}
.search-change{
  padding-right:10px !important;
  border-right:1px solid #000 !important;
  margin-right:10px !important;
  color:#000!important;
}

/* Logo styles */
.logoQ1 {
  height: 40px !important;
  width: auto !important;
  transition: all 0.3s ease !important;
}

/* Responsive logo sizes */
@media screen and (max-width: 1366px) {
  .logoQ1 {
    height: 35px !important;
  }
}

@media screen and (max-width: 1024px) {
  .logoQ1 {
    height: 32px !important;
  }
}

@media screen and (max-width: 768px) {
  .logoQ1 {
    height: 28px !important;
  }
}

@media screen and (min-width: 1920px) {
  .logoQ1 {
    height: 45px !important;
  }
}
	  `;
  document.head.appendChild(style);

  const nav = `
  
        <div class="title">
        <div class="title-child">
            <a href="../homepage.html">
                <img src="../imgs/homepage/logoNew.png" alt="" class = "logoQ1">
            </a>
            <ul class="nav">
                <li class="nav-list">
                    <div class="heng"></div>
                    <a href="../applicationScenarios.html">业务模式</a>
                </li>
                <li class="nav-list">
                    <div class="heng"></div>
                    <a href="../technologyProduct.html">技术产品&nbsp;
                        <img src="../imgs/homepage/形状 1.png" alt="" class = "triangles">
                    </a>
                    <div class="second-nav">
                        <div class="tab-container" id="technologyProduct">
                            <ul class="tab-links"></ul>
                            <div class="tab-content"></div>
                        </div>
                    </div>
                    <div class="triangle"></div>
                </li>
                <li class="nav-list">
                    <div class="heng"></div>
                    <div class="triangle"></div>
                    <a href="../solutions.html">解决方案&nbsp;
                        <img src="../imgs/homepage/形状 1.png" alt="" class = "triangles">
                    </a>
                    <div class="second-nav">
                        <div class="tab-container" id="solutions">
                            <ul class="tab-links"></ul>
                            <div class="tab-content"></div>
                        </div>
                    </div>
                    <div class="triangle"></div>
                </li>
                <li class="nav-list">
                    <div class="heng"></div>
                    <a href="../docs.html">文档</a>
                </li>
                <li class="nav-list">
                    <div class="heng"></div>
                    <a href="../support.html">支持与服务&nbsp;
                        <img src="../imgs/homepage/形状 1.png" alt="" class = "triangles">
                    </a>
                    <div class="second-nav-typeTwo">
                        <div><a href="../valueServices.html" target="_blank">企业支持计划</a></div>
                        <div><a href="../supportService.html" target="_blank">增值服务包</a></div>
                    </div>
                    <div class="triangle"></div>
                </li>
                <li class="nav-list">
                    <div class="heng"></div>
                    <a href="../partnership.html">企业入驻</a>
                </li>
                <li class="nav-list">
                    <div class="heng"></div>
                    <a href="../news.html">资讯</a>
                </li>
                <li class="nav-list">
                    <div class="heng"></div>
                    <a href="../aboutUs.html">关于我们</a>
                </li>
                
            </ul>
            <div class="search-container">
<!--                <div class = "search-change">控制台</div>-->
                <div><a href="https://main.hangtongshuke.com" target="_blank">协同办公</a></div>
            </div>
        </div>
    </div>
              `;
  // <li class="nav-list">
  //       <div class="heng"></div>
  //       <a href="../eachCenter.html" target="_blank">协同办公</a>
  //   </li>
  newNav();
  scheme();
  return nav;
}

function newNav() {
  $.ajax({
    url: "/singleSignLogin/salary-api/api/website/productIntroduction/getCategoryStructure",
    type: "GET",
    dataType: "json",
    success: function (data) {
      if (data.code === 200) {
        let alldata = data.data;
        //一级
        $.each(alldata, function (index, item) {
          if (item.level == 1) {
            let navs = `                             
                         <li>${item.productName}</li>
                        `;
            $("#technologyProduct ul").append(navs);
            let content = `
                           <div class="tab-pane" id = "${item.id}">
                             <div class="tab-pane-child"></div> 
                           </div>
                          `;
            $("#technologyProduct .tab-content").append(content);
            //二级
            if (item.children && item.children.length > 0) {
              $.each(item.children, function (index2, item2) {
                let content2 = `
                                  <div class = "tabContentPro">
                                     <div class = "tabContentTitle">${item2.productName}</div>
                                     <div class = "tabContentPro" id = "tabContentList${item2.id}${index2}"></div>   
                                  </div>                                                         
                                `;
                $("#" + item.id + " " + ".tab-pane-child").append(content2);
                //三级
                if (item2.products && item2.products.length > 0) {
                  $.each(item2.products, function (index3, item3) {
                    let imgHot;
                    if (item3.isHot == 0) {
                      imgHot = `
                                <img src="../imgs/homepage/hot.jpg" alt="">
                                `;
                    } else {
                      imgHot = "";
                    }
                    let content3 = `
                                   <div class = "tabContentListTitle"><a href="${item3.url}">${item3.title}${imgHot}</a></div>
                                   `;
                    $("#tabContentList" + item2.id + index2).append(content3);
                  });
                }
              });
            }
          }
        });
        //#technologyProduct ul下的第一个li添加active
        $("#technologyProduct ul li").eq(0).addClass("active");
        //.tab-content 下的第一个.tab-pane添加active
        $("#technologyProduct .tab-pane").eq(0).addClass("active");
        $(document).ready(function () {
          $("#technologyProduct .tab-links li").click(function () {
            var index = $(this).index();
            $("#technologyProduct .tab-links li").removeClass("active");
            $(this).addClass("active");
            $("#technologyProduct .tab-pane").removeClass("active");
            $("#technologyProduct .tab-pane").eq(index).addClass("active");
          });
        });
      }
    },
    error: function (error) {
      console.error("Error fetching category list:", error);
    },
  });
}

function scheme() {
  $.ajax({
    url: "/singleSignLogin/salary-api/api/website/solution/getSolutionStructure",
    type: "GET",
    dataType: "json",
    success: function (data) {
      if (data.code === 200) {
        let alldata = data.data;
        //一级
        $.each(alldata, function (index, item) {
          if (item.level == 1) {
            let navs = `                             
                        <li>${item.solutionName}</li>
                       `;
            $("#solutions ul").append(navs);
            let content = `
                          <div class="tab-pane" id = "${item.id}">
                            <div class="tab-pane-child"></div> 
                          </div>
                          `;
            $("#solutions .tab-content").append(content);
            //二级
            if (item.children && item.children.length > 0) {
              $.each(item.children, function (index2, item2) {
                let content2 = `
                                <div class = "tabContentPro">
                                  <div class = "tabContentTitle">${item2.solutionName}</div>
                                  <div class = "tabContentPro" id = "tabContentList${item2.id}${index2}"></div>   
                                </div>                                                         
                                `;
                $("#" + item.id + " " + ".tab-pane-child").append(content2);
                //三级
                if (item2.solutions && item2.solutions.length > 0) {
                  $.each(item2.solutions, function (index3, item3) {
                    let imgHot;
                    if (item3.isHot == 0) {
                      imgHot = `
                                <img src="../imgs/homepage/hot.jpg" alt="">
                                `;
                    } else {
                      imgHot = "";
                    }
                    let content3 = `
                                    <div class = "tabContentListTitle"><a href="${item3.url}">${item3.title}${imgHot}</a></div>
                                   `;
                    $("#tabContentList" + item2.id + index2).append(content3);
                  });
                }
              });
            }
          }
        });
        //#technologyProduct ul下的第一个li添加active
        $("#solutions ul li").eq(0).addClass("active");
        //.tab-content 下的第一个.tab-pane添加active
        $("#solutions .tab-pane").eq(0).addClass("active");
        $(document).ready(function () {
          $("#solutions .tab-links li").click(function () {
            var index = $(this).index();
            $("#solutions .tab-links li").removeClass("active");
            $(this).addClass("active");
            $("#solutions .tab-pane").removeClass("active");
            $("#solutions .tab-pane").eq(index).addClass("active");
          });
        });
      }
    },
    error: function (error) {
      console.error("Error fetching category list:", error);
    },
  });
}

export default createNavbar;
